import React from "react";
import { AmplifyTheme, SignOut } from "aws-amplify-react";
import { DropdownItem } from "reactstrap";
import { auth } from "aws-amplify-react/dist/Amplify-UI/data-test-attributes";
import { Auth, Hub, Logger } from "aws-amplify";
import * as Constants from "aws-amplify-react/dist/Auth/common/constants";
import { connect } from "react-redux";
import { removePersistedStorageFromCognitoObject } from "../../helpers/amplifyHelperFunctions";
import IntlMessages from "../../helpers/IntlMessages";
import { setAppPushToken, setFirebaseToken } from "../../libs/firebaseWebpushHandler";
import { updateAuthState } from "../../redux/auth/actions";
import { isMobile } from "react-device-detect";

const logger = new Logger("CustomSignOut", "DEBUG");

class CustomSignOut extends SignOut {
  constructor(props) {
    super(props);
    this.signOut = this.signOut.bind(this);
    this.onHubCapsule = this.onHubCapsule.bind(this);
    Hub.listen("auth", this.onHubCapsule);
    this.state = {};
  }

  componentDidMount() {
    this._isMounted = true;
    this.findState();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  findState() {
    const { authState, authData } = this.props;
    if (!authState && !authData) {
      Auth.currentAuthenticatedUser()
        .then(user => {
          const cleanedUser = removePersistedStorageFromCognitoObject(user);
          this.setState({
            authState: "signedIn",
            authData: cleanedUser,
            stateFromStorage: true
          });
        })
        .catch(err => console.error(err));
    } else if (this.props.stateFromStorage) {
      this.setState({
        stateFromStorage: true
      });
    }
  }

  onHubCapsule(capsule) {
    const { authState } = this.props;
    if (this._isMounted) {
      const { channel, payload } = capsule;
      if (channel === "auth" && payload.event === "signIn") {
        const payloadData = removePersistedStorageFromCognitoObject(payload.data);
        this.setState({
          authState: "signedIn",
          authData: payloadData
        });
      } else if (channel === "auth" && payload.event === "signOut" && !authState) {
        this.setState({
          authState: "signedOut"
        });
      }

      if (channel === "auth" && payload.event === "signIn" && !authState) {
        this.setState({ stateFromStorage: true });
      }
    }
  }

  signOut() {
    const {
      userPrivileges, googleSignOut, facebookSignOut, amazonSignOut, auth0SignOut, authState, updateAuthState
    } = this.props;
    let payload = {};
    try {
      payload = JSON.parse(localStorage.getItem(Constants.AUTH_SOURCE_KEY)) || {};
      localStorage.removeItem(Constants.AUTH_SOURCE_KEY);
    } catch (e) {
      logger.error(`Failed to parse the info from ${Constants.AUTH_SOURCE_KEY} from localStorage with ${e}`);
    }
    switch (payload.provider) {
      case Constants.GOOGLE:
        if (googleSignOut) googleSignOut();
        break;
      case Constants.FACEBOOK:
        if (facebookSignOut) facebookSignOut();
        break;
      case Constants.AMAZON:
        if (amazonSignOut) amazonSignOut();
        break;
      case Constants.AUTH0:
        if (auth0SignOut) auth0SignOut(payload.opts);
        break;
      default:
        break;
    }

    if (!Auth || typeof Auth.signOut !== "function") {
      throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");
    }

    setTokensEmptyString(userPrivileges);

    Auth.signOut()
      .then(() => {
        if (!this.state.stateFromStorage) {
          if (authState !== "signedOut") {
            updateAuthState("signedOut");
          }
        } else {
          if (authState !== "signedOut") {
            updateAuthState("signedOut");
          }
        }
      })
      .catch(err => {
        logger.error(err);
        this.error(err);
      });

    try {
      if (
        window &&
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.StaffBridge &&
        window.webkit.messageHandlers.StaffBridge.postMessage
      ) {
        window.webkit.messageHandlers.StaffBridge.postMessage(`Unsubscribe-${userPrivileges.webPushBaseTopic}`);
        window.webkit.messageHandlers.StaffBridge.postMessage("ClearCache");
      }
      // eslint-disable-next-line no-undef
      if (typeof window.StaffBridge !== "undefined" && window.StaffBridge && window.StaffBridge.postMessage) {
        // eslint-disable-next-line no-undef
        window.StaffBridge.postMessage(`Unsubscribe-${userPrivileges.webPushBaseTopic}`);
        window.StaffBridge.postMessage("ClearCache");
      }
    } catch (err) {
      console.error(err);
    }

    if (navigator.serviceWorker) {
      navigator.serviceWorker.getRegistration().then(reg => {
        reg.unregister().then(() => { });
      });
    }
  }

  render() {
    const authState = this.props.authState || this.state.authState;
    const signedIn = authState === "signedIn";

    const theme = this.props.theme || AmplifyTheme;

    if (!signedIn) {
      return null;
    }

    return (
      <DropdownItem theme={theme} onClick={this.signOut} data-test={auth.signOut.button}>
        <IntlMessages id="user.signout" />
      </DropdownItem>
    );
  }
}

const setTokensEmptyString = async userPrivileges => {
  if (isMobile) {
    await setAppPushToken("");
  } else {
    await setFirebaseToken("", userPrivileges);
  }
};

const mapStateToProps = ({ auth, settings }) => {
  const { authState, authData, userPrivileges } = auth;
  const { error } = settings;
  return {
    authState, authData, userPrivileges, error
  };
};

const mapActionsToProps = {
  updateAuthState,
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(CustomSignOut);
